import { Box } from '@hopskipdrive/react-components';
import { FilterAltRounded } from '@mui/icons-material';

import { ClassificationFilter } from './ClassificationFilter';
import { DateRangeFilter } from './DateRangeFilter';
import { FilterContainer } from './FilterPanel.styles';
import { FiltersSelected } from './FiltersSelected';
import { PriorityFilter } from './PriorityFilter';
import { ReportedPartyFilter } from './ReportedPartyFilter';
import { SlugSearchFilter } from './SlugSearchFilter';
import { StatusFilter } from './StatusFilter';
import { SubclassificationFilter } from './SubclassificationFilter';

const FilterPanel = () => {
  return (
    <Box display="flex" flexDirection="column">
      <FilterContainer>
        <FilterAltRounded />
        <Box display="flex" gap=".69rem" flexWrap="wrap">
          <DateRangeFilter />
          <StatusFilter />
          <ReportedPartyFilter />
          <SlugSearchFilter filterName="account" />
          <SlugSearchFilter filterName="rider" />
          <SlugSearchFilter filterName="careDriver" />
          <PriorityFilter />
          <ClassificationFilter />
          <SubclassificationFilter />
        </Box>
      </FilterContainer>
      <FiltersSelected />
    </Box>
  );
};

export default FilterPanel;
